// The conversation in the platform agent's panel. Wording from the Amigo design's copy sheet; `steps` labels the
// step list (keys in platformAgentConversation.js). The working line's labels are docs/platform-agent/contracts.md
// §5's table, in services/platform-agent/stepLabels.js.
export default {
  conversation: 'Gesprek',
  working: 'Ik ben ermee bezig…',
  stopped: 'Gestopt. Er is niets gewijzigd.',
  step_stopped: 'Gestopt',
  not_sent: 'Niet verzonden',
  failed: {
    text: 'Er ging iets mis aan mijn kant, dus er is niets gewijzigd. Probeer het zo meteen opnieuw.',
    retry: 'Opnieuw proberen',
  },
  question: {
    type_answer: 'Of typ hieronder je antwoord.',
  },
  unavailable: {
    title: {
      amigo: 'Amigo is momenteel niet beschikbaar.',
      assistant: 'De assistent is momenteel niet beschikbaar.',
    },
    text: 'Er is niets gewijzigd en de rest van het dashboard werkt gewoon. Probeer het over een paar minuten opnieuw.',
  },
  // A chat that goes on over several days (D4): a line before each day's first message, and Today to carry on.
  today: 'Vandaag',
  when: {
    today: 'Vandaag, {{time}}',
    yesterday: 'Gisteren, {{time}}',
    date: '{{date}}, {{time}}',
  },
  new_chat_line: 'Nieuwe chat voor {{restaurant}}. De chats van {{previous}} vind je onder Chats als je teruggaat.',
  // Someone else's chat, opened by our team (D4): whose it is, by who started it (contracts §6 `started_by.kind`).
  read_only: {
    whose: {
      foodamigos: 'Chat van {{name}} (FoodAmigos)',
      owner: 'Chat van {{name}} (eigenaar)',
      staff: 'Chat van {{name}} (medewerker)',
      partner: 'Chat van {{name}} (partner)',
      other: 'Chat van {{name}}',
      unnamed: 'Chat van iemand anders',
    },
    text: 'Chat van {{name}}. Je kunt hem lezen, maar niet reageren of de kaarten goedkeuren.',
    text_unnamed: 'Chat van iemand anders. Je kunt hem lezen, maar niet reageren of kaarten goedkeuren.',
    new_chat: 'Nieuwe chat',
  },
  // A chat whose eve session can't go on (QA42): read only, and New chat takes the message that didn't go with it.
  ended: {
    text: 'Dit gesprek is beëindigd. Start een nieuw gesprek om verder te gaan.',
    new_chat: 'Nieuwe chat',
    moved_line: 'Nieuwe chat, omdat de vorige was beëindigd',
  },
  composer: {
    label: 'Bericht',
    placeholder: 'Stel een vraag of beschrijf een wijziging',
    placeholder_answer: 'Typ uw antwoord',
    hint: 'Enter om te verzenden · Shift+Enter voor nieuwe regel',
  },
  table: {
    show_all: 'Alle {{count}} rijen tonen',
    show_fewer: 'Minder tonen',
  },
  steps: {
    areas: 'Controleren waarmee ik hier kan helpen',
    area_describe: 'Bekijken: {{area}}',
    read: 'Je gegevens lezen',
    propose: 'De wijziging voorbereiden',
    change_set_get: 'De wijziging controleren',
    gap_record: 'Dit noteren voor ons team',
    research: 'Opzoeken hoe dit werkt',
    screen_find: 'De juiste pagina zoeken',
    file_read: 'Je bestand lezen',
    shop_check: 'Je shop controleren',
    area_describe_other: 'Dit gedeelte bekijken',
    other: 'Iets controleren',
  },
  // What a step that failed says it couldn't do (QL46), by the area it worked in; `other` is the label without an
  // area. contracts §5's Failed steps, kept the same as STEP_FAILED_LABELS in stepLabels.js (a test holds en and de).
  failed_steps: {
    read: {
      menu: 'Kon het menu niet lezen',
      hours: 'Kon de openingstijden niet lezen',
      order_settings: 'Kon de bestelinstellingen niet lezen',
      my_info: 'Kon je gegevens niet lezen',
      marketing: 'Kon je marketing niet lezen',
      gift_cards: 'Kon de cadeaubonnen niet lezen',
      reports: 'Kon je cijfers niet lezen',
      other: 'Kon je gegevens niet lezen',
    },
    propose: {
      menu: 'Kon de menuwijziging niet voorbereiden',
      hours: 'Kon de wijziging van de openingstijden niet voorbereiden',
      order_settings: 'Kon de wijziging van de bestelinstellingen niet voorbereiden',
      my_info: 'Kon de wijziging van je gegevens niet voorbereiden',
      marketing: 'Kon de marketingwijziging niet voorbereiden',
      gift_cards: 'Kon de wijziging van de cadeaubonnen niet voorbereiden',
      other: 'Kon de wijziging niet voorbereiden',
    },
    change_set_get: { other: 'Kon de wijziging niet controleren' },
    research: { other: 'Kon niet opzoeken hoe dit werkt' },
    screen_find: { other: 'Kon de pagina niet vinden' },
    file_read: { other: 'Kon je bestand niet lezen' },
    shop_check: { other: 'Kon je shop niet openen' },
  },
  // The areas of contracts §0 as the steps name them ("Looking at {{area}}").
  areas: {
    menu: 'het menu',
    hours: 'de openingstijden',
    order_settings: 'de bestelinstellingen',
    my_info: 'de gegevens van je restaurant',
    marketing: 'marketing',
    reports: 'de rapporten',
  },
};
